import React from "react";

const EditAds = () => {
    return <div></div>;
};

export default EditAds;
